module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 151);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=template&id=1464cd48
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "kdv-button",
      class: [
        _vm.type ? "kdv-button--" + _vm.type : "",
        _vm.buttonSize ? "kdv-button--" + _vm.buttonSize : "",
        // TODO:后面都改成is-danger，但是需要通知业务方修改一些重新定义的class
        {
          "is-danger": _vm.danger,
          "is-disabled": _vm.buttonDisabled,
          "is-loading": _vm.loading,
          "is-active": _vm.active || _vm.selfActive,
          "is-icon": _vm.icon,
          // 'is-plain': plain,
          "is-highlight": _vm.highlight,
          // 'is-round': round,
          // 'is-circle': circle,
          "is-menu": _vm.menu,
        },
      ],
      attrs: {
        disabled: _vm.buttonDisabled || _vm.loading,
        autofocus: _vm.autofocus,
        type: _vm.nativeType,
      },
      on: { click: _vm.handleClick },
    },
    [
      _vm.loading
        ? _c("kd-icon", {
            staticClass: "kdv-button--loading",
            attrs: {
              icon: _vm.IconLoading,
              color: _vm.loadingIconColor,
              size: _vm.iconSize,
            },
          })
        : _vm.prefixIcon
        ? _c("kd-icon", {
            staticClass: "kdv-button--prefix",
            attrs: {
              icon: _vm.prefixIcon,
              color: _vm.iconColor || "currentColor",
              size: _vm.iconSize,
            },
          })
        : _vm._e(),
      _vm.$slots.default && !_vm.iconBtnLoading && !_vm.menu
        ? [_vm._t("default")]
        : _vm._e(),
      _vm.$slots.default && !_vm.iconBtnLoading && _vm.menu
        ? [
            _c(
              "div",
              { staticClass: "kdv-button-menu--content" },
              [_vm._t("default")],
              2
            ),
          ]
        : _vm._e(),
      _vm.suffixIcon
        ? _c("kd-icon", {
            staticClass: "kdv-button--suffix",
            attrs: {
              icon: _vm.suffixIcon,
              color: _vm.iconColor || "currentColor",
              size: _vm.iconSize,
            },
          })
        : _vm._e(),
      _vm.menu
        ? _c("kd-icon", {
            staticClass: "kdv-button-menu--arrow",
            attrs: {
              color: _vm.loadingIconColor,
              icon: _vm.IconArrowDown,
              size: _vm.menuIconSize,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=template&id=1464cd48

// EXTERNAL MODULE: external "@kdocs/kdesign-icons-vue-pro/lib/icons/Loading"
var Loading_ = __webpack_require__(17);
var Loading_default = /*#__PURE__*/__webpack_require__.n(Loading_);

// EXTERNAL MODULE: external "@kdocs/kdesign-icons-vue-pro/es/icons/LoadingWhite"
var LoadingWhite_ = __webpack_require__(87);
var LoadingWhite_default = /*#__PURE__*/__webpack_require__.n(LoadingWhite_);

// EXTERNAL MODULE: external "@kdocs/kdesign-icons-vue-pro/lib/icons/ArrowDownS"
var ArrowDownS_ = __webpack_require__(32);
var ArrowDownS_default = /*#__PURE__*/__webpack_require__.n(ArrowDownS_);

// EXTERNAL MODULE: external "@kdocs/kdesign-vue/lib/icon"
var icon_ = __webpack_require__(8);
var icon_default = /*#__PURE__*/__webpack_require__.n(icon_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=script&lang=js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var buttonvue_type_script_lang_js = ({
  name: 'KdButton',
  data: function data() {
    return {
      IconArrowDown: ArrowDownS_default.a,
      selfActive: false
    };
  },

  components: {
    KdIcon: icon_default.a
  },

  props: {
    type: {
      type: String,
      // 主要，次要，轻浅，图标
      default: 'light', // 'primary', 'secondary', 'light', 'icon'
      validator: function validator(value) {
        return ['primary', 'secondary', 'light', ''].includes(value);
      }
    },
    size: {
      type: String,
      // 超大，大，中，小
      default: 'large', // 'x-large', 'large', 'medium', 'small'
      validator: function validator(value) {
        return ['x-large', 'large', 'medium', 'small', ''].includes(value);
      }
    },
    prefixIcon: Object,
    suffixIcon: Object,
    nativeType: {
      type: String,
      default: 'button'
    },
    loading: Boolean,
    danger: Boolean,
    disabled: Boolean,
    active: Boolean,
    icon: Boolean,
    menu: Boolean,
    // plain: Boolean,
    highlight: Boolean, // 强调类型
    autofocus: Boolean,
    // round: Boolean,
    // circle: Boolean,
    iconSize: {
      type: Number | String,
      default: 16
    },
    iconColor: String | Array
  },
  computed: {
    IconLoading: function IconLoading() {
      if (this.type === 'primary') {
        return LoadingWhite_default.a;
      }
      return Loading_default.a;
    },
    loadingIconColor: function loadingIconColor() {
      var fill = '';
      if (this.type === 'primary') {
        fill = 'currentColor';
      }
      return fill;
    },
    menuIconSize: function menuIconSize() {
      if (this.icon) {
        return 12;
      }
      if (this.size === 'x-large') {
        return 16;
      }
      return 12;
    },
    buttonSize: function buttonSize() {
      return this.size;
    },
    buttonDisabled: function buttonDisabled() {
      return this.disabled;
    },
    isComponent: function isComponent() {
      // icon 支持传入string / Component
      return _typeof(this.icon) === 'object';
    },
    iconBtnLoading: function iconBtnLoading() {
      return this.loading && this.icon;
    }
  },

  methods: {
    handleClick: function handleClick(evt) {
      this.$emit('click', evt);
    }
  }
});
// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=script&lang=js
 /* harmony default export */ var src_buttonvue_type_script_lang_js = (buttonvue_type_script_lang_js); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/button/src/button.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_buttonvue_type_script_lang_js,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_button = (component.exports);
// CONCATENATED MODULE: ./packages/button/index.js


/* istanbul ignore next */
src_button.install = function (Vue) {
  Vue.component(src_button.name, src_button);
};

/* harmony default export */ var packages_button = __webpack_exports__["default"] = (src_button);

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = require("@kdocs/kdesign-icons-vue-pro/lib/icons/Loading");

/***/ }),

/***/ 32:
/***/ (function(module, exports) {

module.exports = require("@kdocs/kdesign-icons-vue-pro/lib/icons/ArrowDownS");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@kdocs/kdesign-vue/lib/icon");

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

module.exports = require("@kdocs/kdesign-icons-vue-pro/es/icons/LoadingWhite");

/***/ })

/******/ });